import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedTelephone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.58594 2.37891C8.10556 2.41766 8.565 2.72311 8.80664 3.17383L8.85449 3.27344L8.8584 3.28027L10.5488 7.21777L10.5596 7.24219L10.5674 7.2666C10.5956 7.35102 10.6699 7.55585 10.6699 7.78125C10.6699 8.26394 10.433 8.68119 10.123 8.93164L10.124 8.93262L8.3623 10.373C9.54699 12.6372 11.3774 14.465 13.6465 15.6475L15.0928 13.8887C15.3343 13.5908 15.7481 13.3439 16.209 13.3438C16.3351 13.3438 16.4464 13.3607 16.5391 13.3818L16.7588 13.4463L16.7832 13.4541L16.8076 13.4648L20.7529 15.1523L20.7695 15.1592L20.7861 15.167C21.275 15.411 21.625 15.9413 21.625 16.5352V16.7822L21.6094 16.8516L20.7637 20.5078L20.7607 20.5205L20.7578 20.5322C20.5807 21.1801 20.0244 21.6249 19.3447 21.625C9.94786 21.625 2.375 14.069 2.375 4.6875C2.375 4.00673 2.82208 3.4517 3.46973 3.27539L3.48145 3.27246L3.49414 3.26953L7.15723 2.42578L7.22656 2.41016H7.24902C7.25722 2.40778 7.26955 2.40395 7.2832 2.40039C7.29815 2.3965 7.32184 2.39066 7.34961 2.38574C7.37619 2.38104 7.42029 2.375 7.47363 2.375L7.58594 2.37891Z",
		fill: "#4B7987",
		stroke: "#1F3B44",
		strokeWidth: 1.25
	})]
});
const ForwardRef = forwardRef(SvgOutlinedTelephone);
const Memo = memo(ForwardRef);
export default Memo;
